import { createDynamicSlice } from ".";
import { getDepartmentListThunk } from "../thunks/departmentsThunk";

export const departmentsSlice = createDynamicSlice({
  name: "departments",
  thunk: getDepartmentListThunk,
  listMode: true,
  resetActionName: "resetDepartments",
});

export const departmentsReducer = departmentsSlice.reducer;
export const { resetDepartments } = departmentsSlice.actions;
